// extracted by mini-css-extract-plugin
export default {"container":"CardCopyTrade_container__cU377","header":"CardCopyTrade_header__KO5cq","image":"CardCopyTrade_image__IWdSc","description":"CardCopyTrade_description__YaRWS"};